export default __webpack_public_path__ + "static/media/logo.470a6268.png";